import type { RouteRecordRaw } from 'vue-router';

export function filterAutoGeneratedShopRoute(routes: RouteRecordRaw[]) {
  return routes.filter((route) => route.path !== '/shop');
}
